import { Container, Stack, Text } from '@mantine/core';
import { AuditLogActions } from '../../../enums/retrieve-audit-logs.enum';
import { BasicAuditLog } from '../../../type/retrieve-audit-logs.types';
import LogsChanges from './logs-changes-section.component';
import LogsDetailsSection from './logs-details-section.component';
import LogsExportDetails from './logs-export-details-section.component';

interface Props {
  selectedLog: BasicAuditLog;
}
function LogsDetails(props: Props) {
  const { selectedLog } = props;
  return (
    <>
      <Container
        fluid
        sx={{
          width: '100%',
          position: 'sticky',
          alignSelf: 'flex-start',
          top: 80,
        }}
      >
        <Stack>
          {selectedLog.details.length === 0 ? (
            <Text>No details to display</Text>
          ) : (
            <>
              <LogsDetailsSection selectedLog={selectedLog} />
              {selectedLog.logActionId ===
                AuditLogActions.EXPORT_TRANSACTIONS ||
              selectedLog.logActionId === AuditLogActions.EXPORT_FILES ||
              selectedLog.logActionId === AuditLogActions.CREATE_POS ||
              selectedLog.logActionId === AuditLogActions.UNASSIGN_MID ||
              selectedLog.logActionId === AuditLogActions.ASSIGN_MID ||
              selectedLog.logActionId === AuditLogActions.CREATE_MID ||
              // this changes from `Changes` section to `Description` section
              selectedLog.logActionId === AuditLogActions.LOGIN ||
              selectedLog.logActionId === AuditLogActions.LOGOUT ? (
                <LogsExportDetails selectedLog={selectedLog} />
              ) : (
                <LogsChanges selectedLog={selectedLog} />
              )}
            </>
          )}
        </Stack>
      </Container>
    </>
  );
}

export default LogsDetails;
